export default "__VITE_ASSET__DQS6cNRq__"